import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox'; 
import {MatFormFieldModule} from '@angular/material/form-field';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatInputModule,
    MatCheckboxModule,
    MatFormFieldModule
  ], 
  exports:[ 
    MatInputModule,
    MatCheckboxModule,
    MatFormFieldModule
  ]
})
export class MaterialCommonModule { }
